import { useEffect, useReducer, useRef } from 'react';
import {
  branchTermSingularCapitalised,
  branchTermPluralCapitalised,
} from 'utils/terminology';
import Button from 'components/ui-components/Button';
import AddressBookGrid from '../AddressBookGrid';
import { reducer, initialState } from './reducers/deliver_to_branch_reducer';

const DeliverToBranch = ({
  addresses,
  addressMode,
  getBranches,
  setAddressFromAddressBook,
  setBranchAddressFlag,
  branchAddress,
  showBranchPanel,
  selectedDeliveryAddress,
  showNoBranches,
  hasValidContactDetails,
  signedIn,
}) => {
  const continueButtonRef = useRef();

  const [
    { addressBookAddress, searchPostcode, searchPostcodeError, locationSearch },
    dispatch,
  ] = useReducer(reducer, initialState);

  useEffect(() => {
    if (continueButtonRef.current) continueButtonRef.current.focus();
  }, [continueButtonRef]);

  const handleSearchPostCodeChange = e => {
    dispatch({
      type: 'HANDLE_SEARCH_POSTCODE_CHANGE',
      payload: e.target.value,
    });
  };

  const defineAddress = address => {
    dispatch({ type: 'SET_ADDRESS_BOOK_ADDRESS', payload: address });
  };

  const finaliseAddress = address => {
    if (!signedIn && !hasValidContactDetails()) return;

    setAddressFromAddressBook(address);
    setBranchAddressFlag(true);
  };

  const postcodeSearchError = searchPostcodeError && (
    <span className="search-postcode--error">
      No Addresses found for postcode
    </span>
  );

  return (
    <div
      className={`checkout-sub-panel branch-address ${
        addressMode !== 'BRANCH_DELIVERY' ? 'hide' : ''
      }`}>
      <div className="ip-top-border ip-top-padding">
        <div className="fl-on fl-jc-sb input-address">
          <div className="fl-fb-50-tab fl-fb-30">
            <h2>Search for a {branchTermSingularCapitalised}</h2>
            <label htmlFor="store-search">
              Search by town or postcode <strong className="required">*</strong>
            </label>
            <input
              type="text"
              value={searchPostcode}
              onChange={handleSearchPostCodeChange}
              autoComplete="no"
              id="store-search"
              data-testid={
                !signedIn
                  ? 'guest-store-postcode-input'
                  : 'account-store-postcode-input'
              }
            />
            <button
              onClick={() => {
                getBranches(searchPostcode, locationSearch);
              }}
              disabled={searchPostcode === ''}
              type="button"
              data-testid={
                !signedIn
                  ? 'guest-find-store-address'
                  : 'account-find-store-address'
              }>
              Find Address
            </button>
            {postcodeSearchError}
          </div>
          {signedIn && (
            <div className="fl-fb-50 setCurrentBranch">
              <h2>Deliver to {branchAddress.name}</h2>
              <ul>
                <li>
                  <strong>{branchAddress.name}</strong>
                </li>
                <li>{branchAddress.line_1}</li>
                <li>{branchAddress.line_2}</li>
                <li>{branchAddress.line_3}</li>
                <li>{branchAddress.postcode}</li>
              </ul>
              <button
                className="grey-button"
                onClick={() => {
                  finaliseAddress(branchAddress);
                }}
                type="button">
                Select {branchTermSingularCapitalised}
              </button>
            </div>
          )}
        </div>
        {addresses.length > 0 && showBranchPanel && (
          <>
            <AddressBookGrid
              groupName="address-book-branch"
              addressList={addresses}
              selectedAddress={selectedDeliveryAddress}
              setAddress={defineAddress}
              scrollRef={continueButtonRef}
            />

            <Button
              testId="continue-to-delivery-options"
              className="mt-20 cef-btn cef-btn--green ff-body fw-600 m-mt-30"
              handleClick={() => {
                finaliseAddress(addressBookAddress);
              }}
              disabled={addressBookAddress === ''}
              innerRef={continueButtonRef}>
              Continue to Delivery Options
            </Button>
          </>
        )}
        {showNoBranches && (
          <p className="search-postcode--error">
            No {branchTermPluralCapitalised} Found
          </p>
        )}
      </div>
    </div>
  );
};

export default DeliverToBranch;
